<template>
  <div class="AppMenuTitleBox" v-ripple @click="onClickTitleArea($event)">
    <div class="networkBlinker" v-if="showingDesktopUi">
      <WifiIcon></WifiIcon>
    </div>
    <div style="display: flex; align-items: center; gap: 5px;">
      <div class="siteName" :style="{ opacity: (boardsOnSite.length > 1) ? 0.75 : 1 }">
        {{ store.sessions[0].system.siteName.value }}
        {{ boardsOnSite.length > 1 ? '/' : '' }}
      </div>
      <div class="boardName" v-if="boardsOnSite.length > 1">
        {{ store.sessions[0].system.boardName.value }}
      </div>
    </div>
  </div>
  <Menu ref="boardsMenu" class="boardsMenu" popup :model="boardsMenuItems" @show="onBoardsMenuShow">
    <template #start>
      <div style="display: flex; align-items: center; padding: 10px; gap: 10px;">
        <div style="flex-grow: 1; font-weight: bold; color: var(--gray-400);">
          Boards on site
        </div>
        <Button text size="small" severity="secondary" @click="showBoardsOnSiteDialog()">
          Edit
        </Button>
      </div>
    </template>
    <template #item="{ item }">
      <li style="padding: 10px; display: flex; align-items: center; gap: 5px;" :style="{color: item.board.online.value ? 'black' : 'var(--gray-500)'}">
        <span>
          {{ item.board.boardName.value }}
        </span>
        <span v-if="isThisBoard(item.board)" style="font-size: small;">
          (this board)
        </span>
        <span v-if="!item.board.online.value" style="font-size:small;" >
          (offline)
        </span>
        <span v-if="item.board.location.value == 'remote'" style="font-size:small;" >
          (remote)
        </span>
        <div v-if="store.showAdvanced" style="flex-grow: 1; text-align: right; font-size: 14px; font-style: italic; margin-left: 10px;">
          {{ item.board.ipAddress.value }}
        </div>
      </li>
    </template>
  </Menu>
  <BoardsOnSiteDialog v-model:visible="showingBoardsOnSiteDialog" :boardsOnSite="boardsOnSite"></BoardsOnSiteDialog>
</template>

<script setup>
import { computed, ref } from "vue";
import WifiIcon from "./WifiIcon.vue";
import BoardsOnSiteDialog from "./BoardsOnSiteDialog.vue";
import store, { showingDesktopUi } from "./store";
import { getBoardHostname, handleAdvancedToggleClick, isThisBoard } from "./appUtility.js";

let boardsOnSite = computed(() => {
  return store.sessions[0].system.boardsOnSite.children;
});

let boardsMenu = ref();
let boardsMenuItems = computed(() => {
  return boardsOnSite.value.map(board => ({
    board,
    command: () => {
      if (board.online.value)
        location = `http://${getBoardHostname(board)}`;
    }
  }));
});

let appMenuRect = null;

function onClickTitleArea(event) {
  appMenuRect = document.querySelector(".titleBar, .AppMenuDesktop").getBoundingClientRect();
  boardsMenu.value.toggle(event);
  handleAdvancedToggleClick();
}

function onBoardsMenuShow() {
  // Ensure the boards menu doesn't cover the app menu.
  let boardsMenuEl = document.querySelector(".boardsMenu.p-menu");
  boardsMenuEl.style.top = `${appMenuRect.bottom}px`;

  // Add scrollbars to the boards menu if required.
  boardsMenuEl.style.maxHeight = `calc(100dvh - ${Math.max(8, appMenuRect.bottom)}px)`;
  boardsMenuEl.style.overflowY = "auto";
}

let showingBoardsOnSiteDialog = ref(false);
function showBoardsOnSiteDialog() {
  boardsMenu.value.hide();
  showingBoardsOnSiteDialog.value = !showingBoardsOnSiteDialog.value;
}
</script>

<style scoped>
.AppMenuTitleBox {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding-left: 45px;
  padding-right: 45px;
  min-width: 225px;
}
.AppMenuTitleBox .networkBlinker {
  display: flex;
  align-items: center;
}
.AppMenuTitleBox .siteName {
  display: flex;
  align-items: center;
  justify-content: center;
}
.AppMenuTitleBox .boardName {
  font-weight: normal;
}
</style>